export default function Switch({ checked, defaultChecked, disabled = false, label, onChange, id, style, ...rest }) {
  const inputId = id || (label ? `sw-${String(label).replace(/\s+/g, "-").toLowerCase()}` : undefined);
  const on = checked !== undefined ? checked : undefined;

  const track = {
    width: 46,
    height: 26,
    borderRadius: "var(--radius-pill)",
    flex: "none",
    background: on ? "var(--brand)" : "var(--border-strong)",
    position: "relative",
    transition: "background var(--dur-base) var(--ease-standard)",
  };

  const knob = {
    position: "absolute",
    top: 3,
    left: on ? 23 : 3,
    width: 20,
    height: 20,
    borderRadius: "50%",
    background: "var(--surface-raised)",
    boxShadow: "var(--shadow-sm)",
    transition: "left var(--dur-base) var(--ease-spring)",
  };

  return (
    <label
      htmlFor={inputId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "var(--space-3)",
        fontFamily: "var(--font-body)",
        fontSize: "var(--text-base)",
        color: "var(--text-primary)",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.55 : 1,
        ...style,
      }}
    >
      <span style={{ position: "relative", display: "inline-flex" }}>
        <input
          id={inputId}
          type="checkbox"
          role="switch"
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          onChange={onChange}
          style={{ position: "absolute", opacity: 0, width: 46, height: 26, margin: 0, cursor: "inherit" }}
          {...rest}
        />
        <span style={track} aria-hidden="true">
          <span style={knob} />
        </span>
      </span>
      {label && <span>{label}</span>}
    </label>
  );
}
